/**
 * Mock implementation of the AppContainer component for web
 */
const React = require('react');

// Simple component that just renders its children
function AppContainer(props) {
  return React.createElement('div', {
    style: {
      display: 'flex',
      flex: 1,
      flexDirection: 'column'
    },
    ...props
  }, props.children);
}

module.exports = AppContainer;